import initWorkFilter from './components/work-filter';

const workFilter = document.querySelector('.js-work-filter');

if (workFilter) {
    initWorkFilter(workFilter);
}
